module.exports = __webpack_public_path__ + "img/LI.6144a37a.png";